import BaseStore from './BaseStore';
import _ from 'lodash';
import rp from 'request-promise';
import config from '../config';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';

const defaultData = [];

export class LogActivityStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      data: _.cloneDeep(defaultData),
      select: null,
      display: false,
    });
  }

  setLastLogActivity(data) {
    let activityLog = [];
    data.forEach((val) => {
      let log = {};
      log.id = val.id;
      log.variant = val.variant;
      log.time = val.time;
      log.action = val.action;
      log.patient = val.patient;
      log.activity = val.activity;
      log.router = val.router;
      log.deviceSerial = val.device_serial;
      activityLog.push(log);
    });
    this.data = activityLog;
  }

  async getLastLogActivity(hour) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/changelog/last/${hour}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const data = res.body || {};
        return data;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  addActivity(data) {
    const checkData = (this.data || []).filter((val) => val.deviceSerial === data.deviceSerial);
    if (checkData.length > 0) {
      if (checkData[0].action !== data.action || checkData[0].router !== data.router) {
        this.data.unshift(data);
      }
    } else {
      this.data.unshift(data);
    }
  }

  showLog(status) {
    this.display = status;
  }

  setId(id) {
    if (id === this.select) {
      this.showLog(!this.display);
    } else {
      this.showLog(true);
    }
    this.select = id;
  }
}
export default new LogActivityStore();
